import {Module} from "vuex";
import {RootState} from "@/store/types";
import {userRoles} from "@/store/user_management/roles";
import {partnerUserRoles} from "@/store/user_management/partner_user_roles";
import {partnerUsers} from "@/store/user_management/partner_users";
import {callCenterUsers} from "@/store/user_management/callcenter_users";
import {systemUsers} from "@/store/user_management/system_users";
import {moderationTemplates} from "@/store/user_management/template_moderation";
import {distr_moderation} from "@/store/user_management/distr_moderation";
import {systemActions} from "@/store/user_management/system_actions";
import {actionUsers} from "@/store/user_management/action_users";

export const userManagementModule: Module<any, RootState> = {
  modules: {
    userRoles,
    partnerUserRoles,
    partnerUsers,
    callCenterUsers,
    systemUsers,
    moderationTemplates,
    distr_moderation,
    actionUsers,
    systemActions
  }
}
